/* wellinda-faq-v2 — accordion, one answer open at a time.
   Self-contained: only touches elements inside its own section. */
(function () {
  'use strict';

  function init(root) {
    var items = root.querySelectorAll('[data-wfaq-item]');

    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var head = item.querySelector('[data-wfaq-toggle]');
        if (!head) return;

        head.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');

          for (var j = 0; j < items.length; j++) {
            if (items[j] === item) continue;
            items[j].classList.remove('is-open');
            var other = items[j].querySelector('[data-wfaq-toggle]');
            if (other) other.setAttribute('aria-expanded', 'false');
          }

          item.classList.toggle('is-open', willOpen);
          head.setAttribute('aria-expanded', String(willOpen));
        });
      })(items[i]);
    }
  }

  function boot() {
    var roots = document.querySelectorAll('[data-wfaq]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-wfaq]');
    if (root) init(root);
  });
})();
